<template>
  <v-card class="ma-2">

    <v-toolbar dense>
      <v-toolbar-title> Configurações</v-toolbar-title>
      <v-spacer/>
      <v-btn class="mr-1" small @click="edit" v-if="selected.length == 1">
        <v-icon small title="Editar">fas fa-edit</v-icon>
      </v-btn>
      <v-btn class="mr-1" small @click="removeAll" v-if="selected.length">
        <v-icon small title="Remover Selecionados">fas fa-trash</v-icon>
      </v-btn>
      <v-btn v-if="!error" small @click="create">
        <v-icon small title="Criar">fas fa-plus</v-icon>
      </v-btn>

      <!--
      <v-btn v-if="!error" small @click="loadData">
        <v-icon small title="Buscar">fas fa-search</v-icon>
      </v-btn>
      -->
    </v-toolbar>

    <v-card v-if="error" class="pb-8">
      <v-alert type="error" class="ma-8">
        {{ error }}
      </v-alert>
    </v-card>
    <v-card tile class="pa-4">
      <v-data-table
        v-if="itemsTotal"
        dense
        v-model="selected"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="itemsTotal"
        item-key="id"
        locale="pt-BR"
        show-select
        class="elevation-1"
        @click:row="show"
        show-expand
      >
        <template v-slot:expanded-item="{headers, item}">
          <td :colspan="headers.length">
            <show-details :equivConf="item"/>
          </td>
        </template>
        <template v-slot:item.active="{item}">
          {{ item.active ? 'Sim' : 'Não' }}
        </template>

        <template v-slot:item.currentPlan="{item}">
          <v-tooltip bottom>
            <template v-slot:activator="{on, attrs}">
              <span v-bind="attrs" v-on="on">
                {{ formatDescPlan(item.currentPlan) }}
              </span>
            </template>
            <span>{{ formatLongDescPlan(item.currentPlan) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.referencePlan="{item}">
          <v-tooltip bottom>
            <template v-slot:activator="{on, attrs}">
              <span v-bind="attrs" v-on="on">
                {{ formatDescPlan(item.referencePlan) }}
              </span>
            </template>
            <span>{{ formatLongDescPlan(item.referencePlan) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.proposalPlanOne="{item}">
          <v-tooltip bottom>
            <template v-slot:activator="{on, attrs}">
              <span v-bind="attrs" v-on="on">
                {{
                  item.proposalPlanOne
                    ? formatDescPlan(item.proposalPlanOne.plan)
                    : ''
                }}
              </span>
            </template>
            <span v-if="item.proposalPlanOne">{{
                formatLongDescPlan(item.proposalPlanOne.plan)
              }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.proposalPlanTwo="{item}">
          <v-tooltip bottom>
            <template v-slot:activator="{on, attrs}">
              <span v-bind="attrs" v-on="on">
                {{
                  item.proposalPlanTwo
                    ? formatDescPlan(item.proposalPlanTwo.plan)
                    : ''
                }}
              </span>
            </template>
            <span v-if="item.proposalPlanTwo">{{
                formatLongDescPlan(item.proposalPlanTwo.plan)
              }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.proposalPlanThree="{item}">
          <v-tooltip bottom>
            <template v-slot:activator="{on, attrs}">
              <span v-bind="attrs" v-on="on">
                {{
                  item.proposalPlanThree
                    ? formatDescPlan(item.proposalPlanThree.plan)
                    : ''
                }}
              </span>
            </template>
            <span v-if="item.proposalPlanThree">{{
                formatLongDescPlan(item.proposalPlanThree.plan)
              }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.proposalPlanFour="{item}">
          <v-tooltip bottom>
            <template v-slot:activator="{on, attrs}">
              <span v-bind="attrs" v-on="on">
                {{
                  item.proposalPlanFour
                    ? formatDescPlan(item.proposalPlanFour.plan)
                    : ''
                }}
              </span>
            </template>
            <span v-if="item.proposalPlanFour">{{
                formatLongDescPlan(item.proposalPlanFour.plan)
              }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.proposalPlanFive="{item}">
          <v-tooltip bottom>
            <template v-slot:activator="{on, attrs}">
              <span v-bind="attrs" v-on="on">
                {{
                  item.proposalPlanFive
                    ? formatDescPlan(item.proposalPlanFive.plan)
                    : ''
                }}
              </span>
            </template>
            <span v-if="item.proposalPlanFive">{{
                formatLongDescPlan(item.proposalPlanFive.plan)
              }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.parentId="{item}">
          <router-link
            v-if="item.parentId"
            :to="{
              name: 'equiv_conf_show',
              params: {keyId: item.parentId},
            }"
          >
            <v-icon small title="Chave">fas fa-edit</v-icon>
          </router-link>
        </template>
        <template v-slot:item.startAt="{item}">{{
            $util.formatDateToBR(item.startAt, true)
          }}
        </template>
        <template v-slot:item.endAt="{item}">{{
            $util.formatDateToBR(item.endAt, true)
          }}
        </template>

        <template v-slot:item.actions="{item}">
          <v-layout>
            <router-link
              :to="{
                name: 'equiv_conf_edit',
                params: {keyId: item.id},
              }"
            >
              <v-icon small title="Chave">fas fa-edit</v-icon>
            </router-link>
            &nbsp;
            <router-link
              v-if="!item.parentId"
              :to="{
                name: 'plan_equiv_conf',
                params: {keyId: item.id},
              }"
            >
              <v-icon small title="Planos Equivalentes">fas fa-edit</v-icon>
            </router-link>
            &nbsp;
            <router-link
              v-if="!item.parentId"
              :to="{
                name: 'det_equiv_conf',
                params: {keyId: item.id},
              }"
            >
              <v-icon small title="Detalhes">fas fa-edit</v-icon>
            </router-link>
          </v-layout>
        </template>
      </v-data-table>
    </v-card>
    <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
  </v-card>
</template>

<script>
import {mapMutations} from 'vuex';
import EquivalenceConfigurationService from '@/services/insurancepricing/EquivalenceConfigurationService';
import ShowDetails from './components/show-details';
import DlgConfirmCancel from '@/components/dlg-confirm_cancel.vue';
import XippAuthService from "@/services/auth/XippAuthService";

const service = new EquivalenceConfigurationService();

export default {
  components: {ShowDetails, DlgConfirmCancel},

  data() {
    return {
      headers: [
        {text: 'Atual', align: 'center', value: 'currentPlan', sortable: false},
        {
          text: 'Refêrencia',
          align: 'center',
          value: 'referencePlan',
          sortable: false,
        },
        {
          text: '1° Proposto',
          align: 'center',
          value: 'proposalPlanOne',
          sortable: false,
        },
        {
          text: '2° Proposto',
          align: 'center',
          value: 'proposalPlanTwo',
          sortable: false,
        },
        {
          text: '3° Proposto',
          align: 'center',
          value: 'proposalPlanThree',
          sortable: false,
        },
        {
          text: '4° Proposto',
          align: 'center',
          value: 'proposalPlanFour',
          sortable: false,
        },
        {
          text: '5° Proposto',
          align: 'center',
          value: 'proposalPlanFive',
          sortable: false,
        },
        {text: 'Inicio', align: 'center', value: 'startAt', sortable: true},
        {text: 'Fim', align: 'center', value: 'endAt', sortable: true},
        {text: 'Herança', align: 'center', value: 'parentId', sortable: false},
        {text: 'Ativo', align: 'center', value: 'active', sortable: true},
        {text: '', align: 'center', value: 'actions', sortable: false},
      ],
      options: {},
      itemsTotal: null,
      items: [],
      selected: [],
      error: null,
    };
  },

  beforeCreate() {
    this._xippAuthService = new XippAuthService();
  },
  async created() {
    this.refPlanId = this.$route.query.recordId;

    this.toogleDialogLoading(true);
    try {
      await this.loadJWTToken();
      await this.loadData();
    } catch (error) {
      console.log(error);
      this.error = error;
      this.toogleDialogLoading(false);
    }
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations(['toogleDialogLoading']),
    async loadJWTToken() {
      if (this.$route.query && this.$route.query.token) {
        const sessionKey = "access_token";

        localStorage.setItem(sessionKey, this.$route.query.token);
        await this._xippAuthService.GetTokenFull()
          .then((response) => {
            if (response && response.data) {
              localStorage.setItem(sessionKey, response.data.token);
            }
          });
      }
    },
    async removeAll() {
      this.toogleDialogLoading(true);
      if (
        this.selected.length &&
        await this.$refs.confirm.show('Atenção', 'Deseja excluir os registros selecionados?')
      ) {
        for (const entity of this.selected) {
          await service.delete(entity.id);
        }
        await this.loadData();
      } else {
        this.toogleDialogLoading(false);
      }
    },

    create() {
      this.$router.push(`/equivalence_configuration/${this.refPlanId}/new`);
    },
    show(value) {
      this.$router.push(`/equivalence_configuration/${value.id}/show`);
    },
    edit(value) {
      this.$router.push(
        `/equivalence_configuration/${this.selected[0].id}/edit`,
      );
    },
    async loadData() {
      this.toogleDialogLoading(true);
      const {sortBy, sortDesc, page, itemsPerPage} = this.options;
      const filter = {
        referencePlanId: this.refPlanId,
        page: page ? page - 1 : 0,
        sortBy: sortBy && sortBy.length ? sortBy[0] : 'startAt',
        descending: sortDesc && sortDesc.length ? sortDesc[0] : false,
        size: itemsPerPage === -1 ? 9999 : itemsPerPage,
      };
      try {
        const result = await service.findAllByParams(filter);
        this.items = result.data.content;
        this.itemsTotal = result.data.totalElements;
        this.toogleDialogLoading(false);
      } catch (error) {
        console.log(error);
        this.error = error;
      }
    },

    formatDescPlan(plan) {
      return plan ? `${plan.productCode}` : '*';
    },
    formatLongDescPlan(plan) {
      return plan
        ? `${plan.carrierName} / ${plan.productCode}-${plan.description}`
        : '*';
    },
  },
};
</script>

<style scoped>
table tr:nth-child(even) {
  background-color: var(--v-muted-base);
}
</style>
